import { render, staticRenderFns } from "./EdCollapse.vue?vue&type=template&id=36765a66&"
import script from "./EdCollapse.vue?vue&type=script&lang=js&"
export * from "./EdCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports